import { atom } from "jotai";
export const tipoDocumentoSeleccionadoAtom = atom("");
export const visibleModalConfirmacionAtom = atom();
export const confirmButton = atom();

export const respuestaCertificadoExpiradoAtom = atom("");

export const mostrarAlertaAtom = atom(false);

